import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { IBasketballTeamResponseV2, SDKOptions } from '../../types';
import { generateRequest } from '../http.service';

export const getTeamById = async ({
  team_id,
  sdkOptions,
}: {
  team_id: string;
  sdkOptions: SDKOptions;
}): Promise<IBasketballTeamResponseV2> => {
  const url = `${sdkOptions.dataConfigApiUrl}/teams/${team_id}`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
